<template>
  <a-spin :spinning="loading">
    <a-row class="not-resize-for-mobile">
      <a-col :sm="24" :md="24" :lg="24" :xl="8" :xxl="8">
        <a-card :bordered="false">
          <!-- <a-alert type="warning" :showIcon="true">
            <div slot="message">
              <p>本画面はシステムの初期設定用の画面です。</p>
              <p>運用開始後は利用しないでください、データ不整合が発生する恐れがあります。</p>
            </div>
          </a-alert> -->

          <a-alert type="info" :showIcon="true">
            <div slot="message">
              <span v-if="this.currSelected.title">{{ $t('disp.selected') + '：' }}</span>
              <span v-else>{{ $t('disp.clickTree') }}</span>
              <span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="onClearSelected">{{
                $t('disp.btn.cancel')
              }}</a>
            </div>
          </a-alert>

          <a-input-search
            @search="onSearch"
            style="width: 100%; margin-top: 10px"
            v-model="searchText"
            :placeholder="$t('disp.ph.input', [$t('disp.departName')])"
          />

          <!-- ツリー-->
          <a-col>
            <template>
              <a-dropdown :trigger="[this.dropTrigger]" @visibleChange="dropStatus">
                <span style="user-select: none">
                  <a-empty v-show="departTree.length == 0" style="padding: 55px"></a-empty>
                  <a-tree
                    v-show="departTree.length > 0"
                    checkable
                    multiple
                    @select="onSelect"
                    @check="onCheck"
                    @rightClick="rightHandle"
                    :selectedKeys="selectedKeys"
                    :checkedKeys="checkedKeys"
                    :treeData="departTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    @expand="onExpand"
                  >
                    <span slot="hasSlot" slot-scope="{ title, orgType, key }">
                      <span
                        v-if="orgType == '1'"
                        style="font-size: 16px"
                        v-html="keywordsColorful(title, searchText)"
                      ></span>
                      <span style="font-size: 15px" v-html="keywordsColorful(title, searchText)" v-else></span>
                      <a-icon
                        v-if="key == selectedKeys"
                        type="arrow-left"
                        class="animate__animated animate__fadeInRight"
                        style="margin-left: 8px; color: var(--color-green)"
                      ></a-icon>
                    </span>
                  </a-tree>
                </span>
                <!--右クリックイベント、追加、削除機能を追加-->
                <a-menu slot="overlay">
                  <a-menu-item @click="handleAdd(3)" key="1">{{ $t('disp.btn.add') }}</a-menu-item>
                  <a-menu-item v-if="isLeaf" @click="handleDelete" key="2">{{ $t('disp.btn.delete') }}</a-menu-item>
                  <a-menu-item @click="closeDrop" key="3">{{ $t('disp.btn.cancel') }}</a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </a-col>

          <div class="tree-bootom-button">
            <a-dropdown :trigger="['click']" placement="topCenter">
              <a-menu slot="overlay">
                <a-menu-item key="1" @click="switchCheckStrictly(1)">{{ $t('disp.tree.relation') }}</a-menu-item>
                <a-menu-item key="2" @click="switchCheckStrictly(2)">{{ $t('disp.tree.cancelRelation') }}</a-menu-item>
                <a-menu-item key="3" @click="checkALL">{{ $t('disp.tree.checkALL') }}</a-menu-item>
                <a-menu-item key="4" @click="cancelCheckALL">{{ $t('disp.tree.cancelCheckALL') }}</a-menu-item>
                <a-menu-item key="5" @click="expandAll">{{ $t('disp.tree.expandAll') }}</a-menu-item>
                <a-menu-item key="6" @click="closeAll">{{ $t('disp.tree.closeAll') }}</a-menu-item>
              </a-menu>
              <a-button>
                {{ $t('disp.tree.operation') }}
                <a-icon type="up" />
              </a-button>
            </a-dropdown>
            <a-button icon="plus" v-if="departTree.length == 0" @click="handleAdd(1)">{{
              $t('disp.btn.add')
            }}</a-button>
            <a-button v-if="this.selectedKeys.length > 0" @click="handleAdd(2)">{{
              $t('disp.btn.addChildDepart')
            }}</a-button>
            <a-button v-if="this.checkedKeys.length > 0" @click="batchDel" type="default">{{
              $t('disp.btn.deleteBatch')
            }}</a-button>
          </div>
        </a-card>
      </a-col>
      <a-col :sm="24" :md="24" :lg="24" :xl="16" :xxl="16">
        <a-tabs defaultActiveKey="1" style="padding-left: 30px">
          <a-tab-pane tab="组织信息" key="1">
            <a-empty
              v-show="!currSelected.key"
              :description="$t('msg.I_K0002002_01')"
              style="margin: calc(10% - 32px) 0px 10%"
            />
            <div v-show="currSelected.key" style="width: 85%; margin: 10px 0px 17px">
              <DepartInfo ref="DepartInfo" @emit="loadTree()"></DepartInfo>
            </div>
          </a-tab-pane>

          <a-tab-pane tab="所属员工" key="2" :forceRender="true">
            <DepartUserInfo ref="DepartUserInfo"></DepartUserInfo>
          </a-tab-pane>
        </a-tabs>
      </a-col>

      <DepartModal ref="DepartModal" @emit="onSearch()"></DepartModal>
    </a-row>
  </a-spin>
</template>
<script>
import pick from 'lodash/pick'
import { queryDepartTreeList, searchByKeywords, deleteByDepartId } from '@/api/api'
import { httpAction, deleteAction, getAction } from '@/api/manage'
import { duplicateCheck } from '@/api/api'
import { tableMixin } from '@/mixins/tableMixin'
import DepartInfo from '@/views/k00/k0002/modules/DepartInfo'
import DepartModal from '@/views/k00/k0002/modules/DepartModal'
import DepartUserInfo from '@/views/k00/k0002/modules/DepartUserInfo'

export default {
  name: 'DepartManage',
  mixins: [tableMixin],
  components: {
    DepartInfo,
    DepartModal,
    DepartUserInfo,
  },
  data() {
    return {
      iExpandedKeys: [],
      loading: false,
      autoExpandParent: true,
      searchText: '',
      treeData: [],
      visible: false,
      departTree: [],
      rightClickSelectedKey: '',
      rightClickSelectedIsLeaf: false,
      dropTrigger: '',
      checkedKeys: [],
      selectedKeys: [],
      currSelected: {},
      allTreeKeys: [],
      checkStrictly: true,
      url: {
        delete: '/blaze-sys/k00/k0002/DepartManage/delete',
        deleteBatch: '/blaze-sys/k00/k0002/DepartManage/deleteBatch',
      },
    }
  },
  computed: {
    isLeaf: function () {
      return this.rightClickSelectedIsLeaf
    },
  },
  methods: {
    loadTree() {
      var that = this
      that.iExpandedKeys = []
      that.allTreeKeys = []
      that.treeData = []
      that.departTree = []
      queryDepartTreeList().then((res) => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            that.treeData.push(temp)
            that.departTree.push(temp)
            that.setThisExpandedKeys(temp)
            that.getAllKeys(temp)
          }
        }
      })
    },
    setThisExpandedKeys(node) {
      if (node.children && node.children.length > 0) {
        this.iExpandedKeys.push(node.key)
        for (let a = 0; a < node.children.length; a++) {
          this.setThisExpandedKeys(node.children[a])
        }
      }
    },
    // 右クリック操作
    rightHandle(node) {
      this.dropTrigger = 'contextmenu'
      console.log(node.node)
      this.rightClickSelectedKey = node.node.eventKey
      this.rightClickSelectedIsLeaf =
        node.node.dataRef.parentId == '' || node.node.dataRef.parentId == null ? false : true
    },
    onExpand(expandedKeys) {
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.iExpandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    // ドロップダウンを右クリックしてチェンジイベント
    dropStatus(visible) {
      if (visible == false) {
        this.dropTrigger = ''
      }
    },
    // ドロップダウンを右クリックして閉じる
    closeDrop() {
      this.dropTrigger = ''
    },
    batchDel: function () {
      if (this.checkedKeys.length <= 0) {
        this.$message.warning(this.$t('msg.I_K0002002_01'))
      } else {
        var ids = ''
        for (var a = 0; a < this.checkedKeys.length; a++) {
          ids += this.checkedKeys[a] + ','
        }
        var that = this
        this.$confirm({
          title: that.$t('disp.warn'),
          content: that.$t('msg.W_K0002002_03'),
          onOk: function () {
            if (that.loading) {
              return
            } else {
              // ローディング開始
              that.loading = true
            }

            deleteAction(that.url.deleteBatch, { ids: ids })
              .then((res) => {
                if (res.success) {
                  that.$message.success(that.$t(res.message))
                  that.onSearch()
                  that.onClearSelected()
                }
              })
              .finally(() => {
                that.loading = false
              })
          },
        })
      }
    },
    onSearch() {
      let that = this
      searchByKeywords({ keyWord: that.searchText }).then((res) => {
        if (res.success) {
          that.iExpandedKeys = []
          that.allTreeKeys = []
          that.treeData = []
          that.departTree = []
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            that.treeData.push(temp)
            that.departTree.push(temp)
            that.setThisExpandedKeys(temp)
            that.getAllKeys(temp)
          }
        }
      })
      this.onClearSelected()
    },
    hide() {
      this.visible = false
    },
    onCheck(checkedKeys, info) {
      //this.checkedKeys = checkedKeys.checked
      // <!---- author:os_chengtgen -- date:20190827 --  for:親子チェックモードを切り替え=======------>
      if (this.checkStrictly) {
        this.checkedKeys = checkedKeys.checked
      } else {
        this.checkedKeys = checkedKeys
      }
      // <!---- author:os_chengtgen -- date:20190827 --  for:親子チェックモードを切り替え =======------>
    },
    onSelect(selectedKeys, e) {
      let record = e.node.dataRef

      if (this.selectedKeys.includes(record.key)) {
        this.onClearSelected()
      } else {
        this.selectedKeys = [record.key]
        this.currSelected = Object.assign({}, record)

        this.$refs.DepartInfo.edit(this.currSelected)

        this.$refs.DepartUserInfo.queryParam.username = ''
        this.$refs.DepartUserInfo.onClearSelected()
        this.$refs.DepartUserInfo.open(record)
      }
    },
    getCurrSelectedTitle() {
      return !this.currSelected.title ? '' : this.currSelected.title
    },
    onClearSelected() {
      this.checkedKeys = []
      this.currSelected = {}
      this.selectedKeys = []
      this.$refs.DepartUserInfo.currentDeptId = ''
      this.$refs.DepartUserInfo.parentId = ''
    },
    handleAdd(num) {
      if (num == 1) {
        this.$refs.DepartModal.add(null, 1)
        this.$refs.DepartModal.title = this.$t('disp.btn.add')
      } else if (num == 2) {
        let key = this.currSelected.key
        if (!key) {
          this.$message.warning(this.$t('msg.I_K0002002_01'))
          return false
        }
        this.$refs.DepartModal.add(this.selectedKeys, 2)
        this.$refs.DepartModal.title = this.$t('disp.btn.add')
      } else {
        this.$refs.DepartModal.add(this.rightClickSelectedKey, 2)
        this.$refs.DepartModal.title = this.$t('disp.btn.add')
      }
    },
    handleDelete() {
      var that = this
      this.$confirm({
        title: that.$t('disp.warn'),
        content: that.$t('msg.W_K0002002_04'),
        onOk: function () {
          if (that.loading) {
            return
          } else {
            // ローディング開始
            that.loading = true
          }

          deleteByDepartId({ id: that.rightClickSelectedKey })
            .then((resp) => {
              if (resp.success) {
                that.$message.success(that.$t('msg.delete.success'))
                that.onSearch()
                that.onClearSelected()
              }
            })
            .finally(() => {
              that.loading = false
            })
        },
      })
    },
    // <!---- author:os_chengtgen -- date:20190827 --  for:親子チェックモードを切り替え=======------>
    expandAll() {
      this.iExpandedKeys = this.allTreeKeys
      this.autoExpandParent = true
    },
    closeAll() {
      this.iExpandedKeys = []
    },
    checkALL() {
      this.checkStriccheckStrictlytly = false
      this.checkedKeys = this.allTreeKeys
    },
    cancelCheckALL() {
      //this.checkedKeys = this.defaultCheckedKeys
      this.checkedKeys = []
    },
    switchCheckStrictly(v) {
      if (v == 1) {
        this.checkStrictly = false
      } else if (v == 2) {
        this.checkStrictly = true
      }
    },
    getAllKeys(node) {
      if (!node.disableCheckbox) {
        this.allTreeKeys.push(node.key)
      }

      if (node.children && node.children.length > 0) {
        for (let a = 0; a < node.children.length; a++) {
          this.getAllKeys(node.children[a])
        }
      }
    },
    keywordsColorful(str, key) {
      var reg = new RegExp('(' + key + ')', 'g')
      var newStr = str.replace(reg, "<font style='background:#ff0;'>$1</font>")
      return newStr
    },
  },
  mounted() {
    this.loadTree()
  },
}
</script>
<style lang="less" scoped>
.tree-bootom-button {
  /*position: absolute;*/
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding-top: 10px;
  text-align: left;
  left: 0;
  margin-bottom: -15px;
}

/deep/ .ant-tree-checkbox-disabled {
  display: none;
}
</style>
